"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlPath = exports.joinPath = void 0;

var _lodash = require("lodash");

var _featureDetection = require("@eb/feature-detection");

/**
 * reducePaths
 *
 * Joins paths together and short curcuits for an absolute path
 *
 * @param {string} base path to join additional paths to
 * @param {string} path path to join to base
 */
var reducePaths = function reducePaths(base, path) {
  if (path && path.match && path.match(/^\//)) {
    return path;
  }

  return (0, _lodash.compact)([base && base.replace && base.replace(/\/$/, ''), path]).join('/');
};
/**
 * join parts of a path together, respects absolute paths
 *
 * @param  {...string} parts items in the path to join together
 */


var joinPath = function joinPath() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return (0, _lodash.reduce)(parts, reducePaths, '');
};
/**
 * getUrlPath
 *
 * Get url pathname
 *
 * @return string url pathname
 */


exports.joinPath = joinPath;

var getUrlPath = function getUrlPath() {
  return _featureDetection.HAS_WINDOW ? window.location.pathname : null;
};

exports.getUrlPath = getUrlPath;
//# sourceMappingURL=index.js.map